import { isServer } from "../app/global";

if (isServer()) {
  const { server } = require("./server");
  server.listen();
} else {
  const { worker } = require("./browser");
  // Allow the client to bypass mock service worker for requests where we don't have a mock
  // resolver defined e.g. for requesting static assets
  worker.start({ onUnhandledRequest: "bypass" });
}
